import { createFileRoute, redirect } from '@tanstack/react-router';

// The feature lives on a tab of the bonus hub; this URL stays for old links.
export const Route = createFileRoute('/_player/spin')({
  beforeLoad: () => {
    throw redirect({ to: '/promos', search: { tab: 'spin' } });
  },
});
